<template>
  <div style="width: 100%; height: 100%" ref="ChartLiantongRef"></div>
</template>

<script>
import * as echarts from 'echarts'

export default {
  name: 'ChartLiantong',
  props: {
    chartData: {
      type: Array,
      default: () => ([])
    }
  },
  data() {
    return {}
  },
  computed: {},
  mounted() {
    this.echartsInit()
  },
  methods: {
    echartsInit() {
      const dormitoryNameList = []
      const signInNumList = []
      const openCardNumList = []
      const openCardRateList = []
      this.chartData.forEach(item => {
        const openCardRate = item.openCardRate ? +(item.openCardRate.replace('%', '')) : 0
        dormitoryNameList.push(item.dormitoryName)
        signInNumList.push(item.signInNum || 0)
        openCardNumList.push(item.openCardNum || 0)
        openCardRateList.push(openCardRate)
      })
      // 使用时只需要把setOption里的对象换成echarts中的options或者自己的参数即可
      echarts.init(this.$refs.ChartLiantongRef).setOption({
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
            label: {
              show: true
            }
          }
        },
        grid: {
          left: 80,
          top: 35,
          right: 50,
          bottom: 100
        },
        xAxis: {
          type: 'category',
          data: dormitoryNameList,
          axisLabel: {
            color: '#898989',
            interval: 0,
            rotate: -45
          }
        },
        yAxis: [
          {
            type: 'value',
            name: '人数',
            min: 0,
            axisLabel: {
              color: '#898989',
              formatter: '{value} 人'
            }
          },
          {
            type: 'value',
            name: '开卡率',
            axisLabel: {
              color: '#898989',
              formatter: '{value} %'
            },
            splitLine: {
              show: false
            }
          }
        ],
        series: [
          {
            name: '报到人数',
            data: signInNumList, // 报到人数
            type: 'bar',
            barWidth: '20',
            color: '#c9d1ff',
            itemStyle: {
              normal: {
                barBorderRadius: [3, 3, 0, 0],
                label: {
                  show: false // 是否显示
                }
              }
            }
          },
          {
            name: '开卡人数',
            data: openCardNumList, // 开卡人数
            type: 'bar',
            barWidth: '20',
            barGap: '-100%',
            color: '#3e53f1',
            itemStyle: {
              normal: {
                barBorderRadius: [3, 3, 0, 0],
                label: {
                  show: false, // 是否显示
                  position: 'top', // 显示在顶部
                  textStyle: {
                    color: '#0a1a8b', // 字体颜色
                    fontSize: 10 // 字体大小
                  }
                }
              }
            }
          },
          {
            name: '开卡率',
            data: openCardRateList, // 开卡率
            type: 'line',
            yAxisIndex: 1,
            color: '#facc64',
            tooltip: {
              valueFormatter: function(value) {
                return value + '%'
              }
            },
            itemStyle: {
              normal: {
                label: {
                  show: true, // 是否显示
                  position: 'top', // 显示在顶部
                  formatter: '{c} %',
                  textStyle: {
                    color: '#da9505', // 字体颜色
                    fontSize: 10 // 字体大小
                  }
                }
              }
            }
          }
        ]
      })
    }
  }
}
</script>
<style lang="scss"></style>
